<template>
  <div class="main-wrapper scroll-y custom-scrollbar view-auth">

    <svg class="logo">
      <use xlink:href="#portalgastro-logo"></use>
    </svg>

    <form-login></form-login>

  </div>
</template>

<script>
  import FormLogin from '@/forms/FormLogin';

  export default {
    name: 'Login',
    components: {FormLogin},
    data() {
      return {
        show: false,
      }
    },
    mounted() {
      this.show = true;
    },
  }
</script>